import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const LayoutMultiPageIcon = ({
  title = 'LayoutMultiPage',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props} fill="none">
    {/* prettier-ignore */}
    <rect width="16" height="15" x="3" y="3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx="2" />
    {/* prettier-ignore */}
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8h16M20 7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2" />
  </CreateIconComponent>
);

export default LayoutMultiPageIcon;
